import type {FC} from 'react';
import type {GtagLocation} from '../../../config/constants/gtag';
import {AcEmailVerificationFormPresenter} from './Presenter';
import {useAcEmailVerification} from './useAcEmailVerification';

type Props = {
  gtagLocation: GtagLocation;
  onSubmitted?: () => void;
};

export const AcEmailVerificationFormContainer: FC<Props> = ({
  gtagLocation,
  onSubmitted,
}) => {
  const props = useAcEmailVerification({gtagLocation, onSubmitted});

  return <AcEmailVerificationFormPresenter {...props} />;
};
